import ValuesAsyncSelector from "components/QueryBuilder/ValueAsyncSelector"
import { ValueEditorProps } from "react-querybuilder"

function NomenclatureFiltersValueEditor(props: ValueEditorProps) {
    const { field } = props

    return (
        <ValuesAsyncSelector
            {...props}
            requestData={{
                attribute: field,
            }}
            optionUrl="v1/query-builder/price-nomenclature-filter/values-list"
        />
    )
}

export default NomenclatureFiltersValueEditor
